import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home'
import appdow from '@/pages/appdow/appdow'
import download from '@/pages/appdow/download'
import index from '@/pages/index'
import login from '@/pages/login'
import writing from '@/pages/writing/writing'
import vip from '@/pages/vip/vip'
import editor from '@/pages/editor/editor'
import Account from '@/pages/Account/Account'

Vue.use(Router)
/**
 * 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


var routes = new Router({
  routes: [
    {
      path: '/',
      redirect: '/page/writing',
      name: 'page',
      component: index,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home,
          meta: {
            login: false,
            istoken: false,
            title:'首页'
          }
        },
        {
          path: '/page/appdow',
          name: 'appdow',
          component: appdow,
          meta: {
            login: false,
            title:'APP下载'
          }
        },
        {
          path: '/page/writing',
          name: 'writing',
          component: writing,
          meta: {
            login: true,
            istoken: true,
            title:'创作台'
          }
        }, {
          path: '/page/vip',
          name: 'vip',
          component: vip,
          meta: {
            login: true,
            istoken: true,
            title:'会员中心'
          }
        },
        {
          path: '/page/about',
          name: 'about',
          component: resolve => require(['@/pages/footer/about'], resolve),
          meta: {
            login: false,
            title:'关于我们'
          }
        },
        {
          path: '/page/terms_of_service',
          name: 'terms_of_service',
          component: resolve => require(['@/pages/footer/terms_of_service'], resolve),
          meta: {
            login: false,
            title:'服务条款'
          }
        },
        {
          path: '/page/Account',
          name: 'Account',
          component: Account,
          meta: {
            login: true,
            istoken: true,
            title:'账户中心'
          }
        },
      ]
    },
    {
      path: '/editor',
      name: 'editor',
      component: editor,
      meta:{
        login: true,
        istoken: true,
        title:'论文编辑'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/page/download',
      name: 'download',
      component: download,
      meta: {
        login: false,
        title:'笔杆论文APP下载'
      }
    },

  ]
}
)


routes.beforeEach((to, from, next) => {
  // console.log(to, from)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // console.log(localStorage.getItem('token'))
  if (to.meta.login&&!localStorage.getItem('token')&&to.meta.istoken) {
    next({
      name: 'login',
      params: {
        name: to.name,
        path: to.path,
        params:  to.params,
        query:  to.query
      },
    })
  }
  next({})
});

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js